import { useBreakpoint } from "@/utils/hooks/useBreakpoints";
import { cn } from "@edusogno/lib/utils";

type Props = {
  type: string;
  subtype: string;
  className?: string;
};

const MaterialsBadge = ({ type, subtype, className }: Props) => {
  const breakpoint = useBreakpoint();
  const isSmall = ["xs", "sm", "md"].includes(breakpoint);

  return isSmall ? (
    <div
      className={cn(
        "h-[28px] w-[70px] px-3 leading-[80%] flex flex-col items-center justify-center rounded-[10px] font-semibold border border-[--secondary] text-[--secondary]",
        className
      )}
    >
      <p className="text-[10px]">{type}</p>
      <p className="text-[8px]">{subtype}</p>
    </div>
  ) : (
    <div
      className={cn(
        "h-[30px] w-[90px] flex flex-col items-center justify-center rounded-[10px] leading-3 font-semibold border border-[--secondary] text-[--secondary]",
        className
      )}
    >
      <p className="text-[12px]">{type}</p>
      <p className="text-[8px]">{subtype}</p>
    </div>
  );
};

export default MaterialsBadge;
